__turbopack_context__.v({
  "text": "typography-module__UVP62q__text",
});
